import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=out, obj=in

  const refresh = useCallback(async () => {
    try {
      const u = await api.me();
      setUser(u);
      return u;
    } catch {
      setUser(false);
      return false;
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (email, password) => {
    const u = await api.login(email, password);
    if (u.token) localStorage.setItem("inforno_token", u.token);
    setUser(u);
    return u;
  };

  const changePassword = async (payload) => {
    const r = await api.changePassword(payload);
    if (r.token) localStorage.setItem("inforno_token", r.token);
    await refresh();
    return r;
  };

  const updateProfile = async (payload) => {
    await api.updateProfile(payload);
    return refresh();
  };

  const logout = async () => {
    await api.logout().catch(() => {});
    localStorage.removeItem("inforno_token");
    setUser(false);
  };

  return (
    <AuthCtx.Provider value={{ user, login, logout, changePassword, updateProfile, refresh, setUser }}>
      {children}
    </AuthCtx.Provider>
  );
}
